import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import PaymentMethodsTypes from '../types/PaymentMethodsType';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  allPaymentMethods: { ...initialStateList },
  availablePaymentMethods: [],
  availableCountries: [],
};

export const PaymentMethods = handleActions(
  {
    ...GridFilters,
    [PaymentMethodsTypes.actions.fetchPaymentMethodsFiltersSuccess]: (state, { payload: { availableCountries, availablePaymentMethods } }) => ({
      ...state,
      availableCountries,
      availablePaymentMethods,
    }),
  },
  initialState
);

const getPaymentMethods = (state) => state.PaymentMethods;

export const getPaymentMethodsList = (state, list) => {
  const paymentMethods = getPaymentMethods(state);
  return paymentMethods[list] || undefined;
};

export const getPaymentMethodsCountries = createSelector(getPaymentMethods, (state) => state.availableCountries);

export const getAvailablePaymentMethods = createSelector(getPaymentMethods, (state) => state.availablePaymentMethods);
